module.exports = __webpack_public_path__ + "static/img/partner-jh.0f8f59b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-jh.png
// module id = PLa8
// module chunks = 34